import { useState } from 'react';
import { useInquiry } from './InquiryProvider';
import { InquiryCommentTemplate } from '@/types/api';
import { motion, AnimatePresence } from 'framer-motion';
import { Dialog, DialogContent, DialogTrigger } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/NewPcButton';
import { ListTemplate } from './ListTemplate';
import { AddOrEditTemplate } from './AddOrEditTemplate';

const EditTemplate = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'list' | 'add' | 'edit'>('list');
  const { templateList } = useInquiry();

  // 템플릿 추가/편집 화면에서 사용할 상태
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [editTemplateNo, setEditTemplateNo] = useState<number | null>(null);

  // 다이얼로그 닫힐 때 상태 초기화
  const handleDialogChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (!isOpen) {
      setMode('list');
      setTitle('');
      setContent('');
      setEditTemplateNo(null);
    }
  };

  // 템플릿 편집 진입
  const handleEdit = (tpl: InquiryCommentTemplate) => {
    setEditTemplateNo(tpl.TemplateNo);
    setTitle(tpl.Title);
    setContent(tpl.Content);
    setMode('edit');
  };

  // 템플릿 추가 진입
  const handleAdd = () => {
    setEditTemplateNo(null);
    setTitle('');
    setContent('');
    setMode('add');
  };

  // 목록 복귀
  const handleBackToList = () => {
    setMode('list');
    setTitle('');
    setContent('');
    setEditTemplateNo(null);
  };
  return (
    <Dialog open={open} onOpenChange={handleDialogChange}>
      <DialogTrigger asChild>
        <div className="sticky right-0 flex h-full items-center gap-[10px] bg-white/10 pl-[20px] backdrop-blur-[5px]">
          <Button variant="solid" size="small" className="w-fit" onClick={() => setOpen(true)}>
            템플릿 편집
          </Button>
        </div>
      </DialogTrigger>
      <DialogContent
        noCloseBtn
        className="h-[458px] max-w-[620px] overflow-x-hidden rounded-xl bg-white p-[30px]"
      >
        <div className="h-full w-full overflow-x-hidden">
          <AnimatePresence initial={false} mode="popLayout">
            {mode === 'list' && (
              <motion.div
                key="list"
                initial={{ x: -420, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="h-full w-full"
              >
                <ListTemplate templateList={templateList} onAdd={handleAdd} onEdit={handleEdit} />
              </motion.div>
            )}
            {mode === 'add' && (
              <motion.div
                key="add"
                initial={{ x: 420, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="h-full w-full"
              >
                <AddOrEditTemplate
                  title={title}
                  setTitle={setTitle}
                  content={content}
                  setContent={setContent}
                  onBack={handleBackToList}
                  mode="add"
                />
              </motion.div>
            )}
            {mode === 'edit' && (
              <motion.div
                key="edit"
                initial={{ x: 420, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="h-full w-full"
              >
                <AddOrEditTemplate
                  title={title}
                  setTitle={setTitle}
                  content={content}
                  setContent={setContent}
                  onBack={handleBackToList}
                  mode="edit"
                  editTemplateNo={editTemplateNo}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditTemplate;
